// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"748":"311c3a80","1900":"25e54d09","1949":"cdab7f20","2615":"cdab7f20","4677":"1df0b60f","6230":"c64fa0c0","7833":"cdab7f20","8341":"cdab7f20","8830":"80c73783"}[chunkId] + ".chunk.css";
};